<template>
	<div class="addrole">
		<el-card class="box-card">
			<div class="card-header">
				<span>角色名称：</span>
				<el-input v-model="rolename" size="small" :disabled="isedit == 1"></el-input>
			</div>
			<div class="card-content" :style="{ height: height }">
				<div class="item" v-for="(item, index) in link" :key="index">
					<div class="second-item">
						<div class="second-header">
							<el-checkbox v-model="item.ischeck" false-label="0" true-label="1" @change="changeHandle(index)">{{ item.name }}</el-checkbox>
						</div>
						<div class="second-body">
							<div class="second-item" v-for="(i, secondIndex) in item.sonlink" :key="secondIndex">
								<el-checkbox v-model="i.ischeck" false-label="0" true-label="1" class="second-cbx" @change="changeHandle(index, secondIndex)">
									{{ i.name }}
								</el-checkbox>
								<div class="lastBox">
									<div class="last-item" v-for="(sonItem, lastIndex) in i.sonlink" :key="lastIndex">
										<el-checkbox
											v-model="sonItem.ischeck"
											class="second-cbx"
											false-label="0"
											true-label="1"
											@change="changeHandle(index, secondIndex, lastIndex)"
										>
											{{ sonItem.name }}
										</el-checkbox>
										<div class="sonBox">
											<el-checkbox
												v-model="lastItem.ischeck"
												class="last-cbx"
												false-label="0"
												true-label="1"
												v-for="lastItem in sonItem.sonlink"
												:key="lastItem.l_id"
												@change="checksonbox(lastItem.l_id, lastItem.ischeck)"
											>
												{{ lastItem.name }}
											</el-checkbox>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="footerrole">
				<el-button type="primary" size="small" @click="saverole">保 存</el-button>
				<el-button size="small" @click="closepage(false)">取 消</el-button>
			</div>
		</el-card>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	props: {
		urlparam: {
			type: Object,
			default:{}
		}
	},
	data() {
		return {
			rolename: '',
			height: (window.innerHeight * 74) / 100 - 32 + 'px',
			link: [],
			isedit: 0,
			checkedid: [], //已勾选的
			islist: false //是否从角色列表中打开
		};
	},
	mounted() {
		//document.getElementsByClassName('el-tabs__header is-top')[0].style.margin = 0;
		this.$apipost.get.getTheme().then(res => {
			//debugger
			import('../../static/' + res + '/style/user/addrole.scss');
			this.getpermession();
		});
		if (this.urlparam.ty != undefined) {
			this.islist = true;
		} else {
			this.islist = false;
		}
		if (this.urlparam.rolename != undefined) {
			this.rolename = unescape(this.urlparam.rolename);
		}
		if (this.rolename != '') {
			this.isedit = 1;
		}
		
	},
	methods: {
		checksonbox(l_id, ischeck) {
			var e = new Object();
			e.l_id = l_id;
			e.ischeck = ischeck;
			this.getcheckbox(e);
		},
		//选中改变checkbox状态
		changeHandle(index, secondIndex, lastIndex) {
			let that = this;
			if (lastIndex != undefined) {
				that.getcheckbox(that.link[index].sonlink[secondIndex].sonlink[lastIndex]);
				if(that.link[index].sonlink[secondIndex].sonlink[lastIndex].sonlink.length>0){
					that.link[index].sonlink[secondIndex].sonlink[lastIndex].sonlink.forEach(element => {
						element.ischeck = that.link[index].sonlink[secondIndex].sonlink[lastIndex].ischeck;
						that.getcheckbox(that.link[index].sonlink[secondIndex].sonlink[lastIndex]);
						that.getcheckbox(element);
					});
				}
				return;
			}
			if (secondIndex !== undefined) {
				that.getcheckbox(this.link[index].sonlink[secondIndex]);
				if(this.link[index].sonlink[secondIndex].sonlink.length>0){
					this.link[index].sonlink[secondIndex].sonlink.forEach(element => {
						element.ischeck = this.link[index].sonlink[secondIndex].ischeck;
						that.getcheckbox(element);
						element.sonlink.forEach(e => {
							e.ischeck = element.ischeck;
							that.getcheckbox(e);
						});
					});
				}
				else{
					that.getcheckbox(this.link[index].sonlink[secondIndex]);
				}
				return;
			}
			that.getcheckbox(this.link[index]);
			this.link[index].sonlink.forEach(element => {
				element.ischeck = this.link[index].ischeck;
				that.getcheckbox(element);
				if (element.sonlink.length > 0) {
					element.sonlink.forEach(e => {
						e.ischeck = element.ischeck;
						that.getcheckbox(e);
						if (e.sonlink.length > 0) {
							e.sonlink.forEach(i => {
								i.ischeck = e.ischeck;
								that.getcheckbox(i);
							});
						}
					});
				}
			});
		},
		//获取权限功能选择框
		getpermession() {
			var that = this;
			this.$tool.loading('正在加载角色', 'addrole');
			this.$apipost.get.GetPermession({ rolename: this.rolename }).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					that.link = res.list;
					that.setchecked(res.list);
				}
			});
		},
		setchecked(list){
			var that=this;
			list.forEach(e=>{
				if(e.ischeck=='1')
					that.checkedid.push(e.l_id);
				if(e.sonlink.length>0){
					that.setchecked(e.sonlink);
				}
			});
		},
		//保存角色
		saverole() {
			var that = this;
			if (this.$tool.formatinput(this.rolename) == '') {
				this.$message.error('请输入角色名称');
				return false;
			}
			if (this.checkedid == '') {
				this.$message.error('请勾选权限');
				return false;
			}
			this.$tool.loading('正在保存', 'addrole');
			//console.log('permessionid',JSON.stringify( this.checkedid));
			this.$apipost.post.SaveRoleInfo({ permessionid: this.checkedid, isedit: this.isedit, rolename: this.rolename }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$message({
						message: '设置成功',
						type: 'success'
					});
					that.closepage(true);
				} else {
					this.$message.error(res.message);
				}
			});
		},
		//取消保存
		closepage(isrefresh) {
			if(this.isedit==0){
				Utils.$emit('handleRermove','新增角色');
			}else{
				Utils.$emit('handleRermove','修改角色');
			}
		},
		//获取已勾选的checkbox
		getcheckbox(element) {
			var that = this;
			if (element.ischeck == '1') {
				that.checkedid.push(element.l_id); //已选中，添加l_id
			} else {
				var i = 0;
				that.checkedid.forEach(checked => {
					if (checked.toString() == element.l_id) {
						//取消选中，查找到就移除
						that.checkedid.splice(i, 1);
						return false;
					}
					i++;
				});
			}
		}
	}
};
</script>
